import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import { RefObject } from 'react';
import { gsap } from '@/lib/gsap';
import css from '../style.module.scss';
export const useCasesSliderMobileReveal = (sectionRef, enabled, slidesCount) => {
  const $ = _c(9);
  let t0;
  if ($[0] !== enabled || $[1] !== sectionRef) {
    t0 = () => {
      const section = sectionRef.current;
      if (!section || !enabled) {
        return;
      }
      const cards = gsap.utils.toArray(`.${css.mobileCard}`, section);
      cards.forEach(_temp);
    };
    $[0] = enabled;
    $[1] = sectionRef;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== enabled || $[4] !== slidesCount) {
    t1 = [enabled, slidesCount];
    $[3] = enabled;
    $[4] = slidesCount;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== sectionRef || $[7] !== t1) {
    t2 = {
      scope: sectionRef,
      dependencies: t1
    };
    $[6] = sectionRef;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useGSAP(t0, t2);
};
function _temp(card) {
  const topContent = card.querySelector(`.${css.topContent}`);
  const bottomContent = card.querySelector(`.${css.bottomContent}`);
  if (topContent) {
    gsap.set(topContent, {
      opacity: 0,
      y: 24
    });
    gsap.to(topContent, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out",
      scrollTrigger: {
        trigger: card,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });
  }
  if (bottomContent) {
    gsap.set(bottomContent, {
      opacity: 0,
      y: 24
    });
    gsap.to(bottomContent, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out",
      scrollTrigger: {
        trigger: bottomContent,
        start: "top 90%",
        toggleActions: "play none none reverse"
      }
    });
  }
}